import { Router } from '@angular/router';
import { ShSharesDataService } from '@stylehaven/components';
import { Observable } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

export const shareTokenResolver: (
    router: Router,
    shareService: ShSharesDataService,
    shareId: string
) => Observable<string> = (router, shareService, shareId) =>
    shareService.getShareToken(shareId).pipe(
        take(1),
        catchError(async (error: any) => {
            if (error?.status === 410) {
                await router.navigateByUrl('/shared/expired', { skipLocationChange: true });
            }
            throw error;
        })
    );
